import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Immutable from 'immutable';
import * as irActions from '../../../redux/actions/irSearch';
import LoadingBar from '../../common/LoadingBar';
import FilterTable from '../../common/FilterTable';
import AllPartsPrintPreview from './AllPartsPrintPreview';
import EmailCombinedPdfPopup from './popups/EmailCombinedPdfPopup';
import DownloadZipAllPdfsRangePopup from './popups/DownloadZipAllPdfsRangePopup';
import DownloadCombineAllPdfInRangePopup from './popups/DownloadCombineAllPdfInRangePopup';
import DownloadZipWithSubpartsPopup from './popups/DownloadZipWithSubpartsPopup';
import PrintAllPdfInRangePopup from './popups/PrintAllPdfInRangePopup';
import EmailPartPopup from './popups/EmailPartPopup';
import EmailAllPartsZipPopup from './popups/EmailAllPartsZipPopup';
import EmailFormPopup from './popups/EmailFormPopup';
import dateFormat from '../../../utils/dateFormat';
import DocketHeader from './DocketHeader';
import DocketEntries from './DocketEntries';
import DocketFilters from './DocketFilters';
import DocketPacerSearchBar from './DocketPacerSearchBar';
import * as docketsConstants from '../../../constants/docketsConstants';
import Flash from './Flash';
import DocketsPaginator from './DocketsPaginator';
import UpdateRedact from './UpdateRedact';
import SearchReceipt from '../../search/results/searchReceipt/SearchReceipt';
import MissingEntriesTooltip from './MissingEntriesTooltip';
import LastFilingTooltip from './LastFilingTooltip';
import DocketError from './DocketError';
import './Docket.less';

require('classlist-polyfill');
require('react-datepicker/dist/react-datepicker.css');


const initState = {
  docNumFrom: null,
  docNumTo: null,
  startDate: null,
  endDate: null,
  pacerSearch: {
    startDate: null,
    endDate: null,
    doc_from: null,
    doc_to: null,
  },
  doc_range: '',
  keyword: '',
  sort_field: 'docket_no',
  sort_direction: window.Drupal.settings.docket_sort_order || 'desc',
  docket_sort_order: window.Drupal.settings.docket_sort_order,
  collapseHeader: !(window.Drupal.settings.auto_show_docket_header === 'yes'),
};

export class Docket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initState,
      selectedPageNum: 1,
      page: 0,
      showSearchBar: true,
      showLoadingBar: false,
      loadCount: 0,
      showPastEntries: false,
      showRedactPopup: false,
      redactSeqNum: null,
      selectedDocketDetailNum: null,
      contactingPacer: false,
    };
  }

  componentDidMount() {
    if (this.props.purchase_right_away) {
      this.purchaseData();
    } else {
      const { sort_direction } = this.state;
      this.getData({}, { sort_direction });
    }
  }

  componentDidUpdate(prevProps) {
    // quick stop gap.  need to fix this somewhere else, probably service layer
    window.fixHeaderAssociatedCasesButton();
    window.$("#docket-header-content a[href^='/cgi-bin']").hide();


    if (prevProps.dataReady !== this.props.dataReady && this.props.dataReady) {
      const hasHeaders = (
        !_.isEmpty(this.props.dockets.headers)
        && this.props.dockets.headers.text
        && this.props.dockets.headers.text.length > 0
      );
      const hasEntries = this.props.dockets.entries && this.props.dockets.entries.length > 0;
      const showSearchBar = !hasHeaders && !hasEntries && this.state.loadCount < 1 && _.isEmpty(this.props.error);

      this.setState({
        showSearchBar,
        showLoadingBar: false,
        contactingPacer: false,
        loadCount: this.state.loadCount + 1,
        redactSeqNum: null,
        showPastEntries: false,
      });
    }
  }

  onPopupClick = (params = {}) => {
    this.props.dispatch({ type: docketsConstants.RESET_DOCKETS_PARTS });

    const popup = (params.show)
      ? { ...params }
      : { show: false };

    this.props.dispatch({
      type: docketsConstants.DOCKETS_POPUP,
      popup,
    });
  }

  getData = (headerParams = {}, itemParams = {}) => {
    this.setState({ showLoadingBar: true });
    const { case_uuid } = this.props;

    this.props.dispatch(irActions.getDockets(
      { ...headerParams, case_uuid },
      { ...itemParams, case_uuid },
      this.state.sort_direction,
      this.state.selectedPageNum,
    ));
  }

  purchaseData = () => {
    this.setState({ showLoadingBar: true, contactingPacer: true });

    this.props.dispatch(irActions.purchaseDockets(
      {
        type: 'dockets',
        case_uuid: this.props.case_uuid,
        sort_direction: this.state.sort_direction,
      },
      this.state.selectedPageNum,
    ));
  }

  changeDate = (type, date) => {
    this.setState({ [type]: date });
  }

  changePacerDate = (type, date) => {
    const pacerSearch = { ...this.state.pacerSearch, [type]: date };
    this.setState({ pacerSearch });
  }

  handleDateChangeRaw = (type, e) => {
    const date = e.target.value;
    if (date.split('/').length !== 3) {
      return;
    }

    const sanitized = date.split('/').reduce((accum, next, idx) => {
      const n = (next.length < 2)
        ? `0${next}`
        : next;

      return (idx === 0)
        ? accum + n
        : `${accum}/${n}`;
    }, '');

    const d = moment(sanitized, 'MM-DD-YYYY');

    this.setState({ [type]: d });
  }

  handlePacerDateChangeRaw = (type, e) => {
    const date = e.target.value;
    if (date.split('/').length !== 3) {
      return;
    }

    const sanitized = date.split('/').reduce((accum, next, idx) => {
      const n = (next.length < 2)
        ? `0${next}`
        : next;

      return (idx === 0)
        ? accum + n
        : `${accum}/${n}`;
    }, '');

    const d = moment(sanitized, 'MM-DD-YYYY');

    const pacerSearch = { ...this.state.pacerSearch, [type]: d };

    this.setState({ pacerSearch });
  }

  clear = () => {
    this.setState(initState);
  }

  buyDocketSheet = (calledFromUpdate = false) => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      const { pacerSearch, sort_direction } = this.state;
      const { startDate, endDate, doc_from, doc_to } = pacerSearch;

      const params = {
        case_uuid: this.props.case_uuid,
        is_ajax: 1,
        receipt_only: 1,
        query: 'dockets',
        date_from: startDate ? startDate.format('MM/DD/YYYY') : null,
        date_to: endDate ? endDate.format('MM/DD/YYYY') : null,
        doc_from,
        doc_to,
        sort_direction,
      };

      this.setState({ showLoadingBar: true, contactingPacer: true });

      // this.props.dispatch(irActions  .getDockets(params));
      this.props.dispatch(irActions.purchaseDockets(params, this.state.selectedPageNum, calledFromUpdate));
    }
  }

  buyMissingDockets = (docNumRange) => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      this.setState({ showLoadingBar: true, contactingPacer: true });
      const date_from = docNumRange.prev_date_filed;
      const date_to = docNumRange.next_date_filed;

      const params = {
        case_uuid: this.props.case_uuid,
        is_ajax: 1,
        receipt_only: 1,
        query: 'dockets',
        doc_from: null,
        doc_to: null,
        date_from,
        date_to,
      };
      this.props.dispatch(irActions.purchaseDockets(params, this.state.selectedPageNum));
    }
  }

  buyFilteredDockets = () => {
    const { startDate, endDate, doc_range, keyword } = this.state;

    const params = {
      case_uuid: this.props.case_uuid,
      // is_ajax: 1,
      // receipt_only: 1,
      query: 'dockets',
      date_from: startDate ? startDate.format('MM-DD-YYYY') : '_',
      date_to: endDate ? endDate.format('MM-DD-YYYY') : '_',
      doc_range: _.isEmpty(doc_range) ? '_' : doc_range,
      keyword: _.isEmpty(keyword) ? '_' : keyword,
      page: this.state.page,
      page_index: this.state.selectedPageNum,
    };

    return this.props.dispatch(irActions.getItems(params, this.state.sort_direction, this.state.selectedPageNum));
  }

  onClear = () => {
    const { startDate, endDate, doc_range, keyword, pacerSearch } = initState;
    const state = {
      startDate,
      endDate,
      doc_range,
      keyword,
      pacerSearch,
      showLoadingBar: true,
    };

    this.setState(state, () => {
      this.buyFilteredDockets();
    });
  }

  getDocketDetails = (seqNum) => {
    this.setState({ selectedDocketDetailNum: seqNum }, () => {
      const params = { case_uuid: this.props.case_uuid, seqNum };
      this.props.dispatch(irActions.getDocketDetails(params));
    });
  }

  popupForm = {
    EmailCombinedPdfPopup,
    AllPartsPrintPreview,
    DownloadZipAllPdfsRangePopup,
    DownloadZipWithSubpartsPopup,
    DownloadCombineAllPdfInRangePopup,
    PrintAllPdfInRangePopup,
    EmailPartPopup,
    EmailAllPartsZipPopup,
    EmailFormPopup,
    // ZipAllPdfsInRangePopup,
  }

  changePage = (headerParams, itemParams) => {
    this.setState({ selectedPageNum: itemParams.page_index, page: itemParams.page });
    this.getData(headerParams, itemParams);
  }

  sortDockets = (sort_field) => {
    const sort_direction = (this.state.sort_direction === 'asc')
      ? 'desc'
      : 'asc';

    this.setState({ sort_field, sort_direction });
    this.getData({}, { sort_field, sort_direction });
  }

  toggleHeader = () => {
    this.setState({ collapseHeader: !this.state.collapseHeader });
  }

  pastEntriesClick = () => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      this.setState({ showSearchBar: true, showPastEntries: true });
    }
  }

  pastEntriesHide = () => {
    this.setState({ showSearchBar: false, showPastEntries: false });
  }

  updateClick = () => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      let { startDate } = this.state.pacerSearch;

      if (_.isEmpty(startDate) && !_.isEmpty(this.props.dockets.entries)) {
        const entries = this.props.dockets.entries.filter(p => p.meta);
        const sorted = _.sortBy(entries, entry => moment(entry.meta.date_filed, 'MM/DD/YYYY'))
          .reverse();
        startDate = moment(sorted[0].meta.date_filed, 'MM/DD/YYYY');
      }

      const pacerSearch = { ...this.state.pacerSearch, startDate };
      const state = {
        ...initState,
        pacerSearch,
        showSearchBar: true,
        showPastEntries: true,
        collapseHeader: this.state.collapseHeader,
      };

      this.setState(state, () => {
        this.buyDocketSheet(true);
      });
    }
  }

  showRedactPopup = (seqNum) => {
    this.setState({ showRedactPopup: true, redactSeqNum: seqNum });
  }

  closeRedactPopup = () => {
    this.setState({ showRedactPopup: false, redactSeqNum: null });
  }

  redact = () => {
    const { redactSeqNum } = this.state;
    this.setState({ showRedactPopup: false });
    const num = parseFloat(redactSeqNum);
    const doc_range = (num % 1 === 0)
      ? num
      : '_';

    const { case_uuid } = this.props;

    const params = {
      doc_range,
      case_uuid,
    };

    this.props.dispatch(irActions.getItems(params, this.state.sort_direction, this.state.selectedPageNum));
  }

  reloadDetails = () => {
    this.buyFilteredDockets()
      .then(() => this.getDocketDetails(this.state.selectedDocketDetailNum));
  }

  buyPdf = (docket_no, number, seqNum) => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      const params = {
        case_uuid: this.props.case_uuid,
        docket_no,
        number,
        seqNum,
      };

      this.props.dispatch(irActions.buyPdf(params))
        .then(this.reloadDetails);
        // .then(() => this.getDocketDetails(seqNum));
    }
  }

  changeFilter = (e, name) => {
    this.setState({ [name]: e.target.value });
  }

  changePacerFilter = (e, name) => {
    const pacerSearch = { ...this.state.pacerSearch, [name]: e.target.value };
    this.setState({ pacerSearch });
  }

  allFiltersEmpty = () => {
    const filtersAreEmpty = _.isEmpty(this.state.keyword)
      && _.isEmpty(this.state.doc_range)
      && _.isEmpty(this.state.startDate)
      && _.isEmpty(this.state.endDate);

    const pacerFiltersAreEmpty = _.isEmpty(this.state.pacerSearch.startDate)
      && _.isEmpty(this.state.pacerSearch.endDate)
      && _.isEmpty(this.state.pacerSearch.doc_from)
      && _.isEmpty(this.state.pacerSearch.doc_to);

    return filtersAreEmpty && pacerFiltersAreEmpty;
  }


  render() {
    let { headers = {}, entries = {}, showMissingDockets } = this.props.dockets;

    headers = Immutable.Iterable.isIterable(headers)
      ? headers.toJS()
      : headers;

    entries = Immutable.Iterable.isIterable(entries)
      ? entries.toJS()
      : entries;

    let lastUpdated = '';

    if (headers.meta && headers.meta.timestamp) {
      lastUpdated = dateFormat(headers.meta.timestamp * 1000, 'M/D/YYYY h:mm a');
    }

    showMissingDockets = showMissingDockets && this.allFiltersEmpty();

    const docketFilterProps = {
      keyword: this.state.keyword,
      doc_range: this.state.doc_range,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      onChange: this.changeFilter,
      changeDate: this.changeDate,
      onChangeDateRaw: this.handleDateChangeRaw,
      buyFilteredDockets: () => this.setState({ showLoadingBar: true }, this.buyFilteredDockets),
      onClear: this.onClear,
    };

    const docketSearchBarProps = {
      showLoadingBar: this.state.showLoadingBar,
      showPastEntries: this.state.showPastEntries,
      pastEntriesHide: this.pastEntriesHide,
      changePacerFilter: this.changePacerFilter,
      changePacerDate: this.changePacerDate,
      handlePacerDateChangeRaw: this.handlePacerDateChangeRaw,
      pacerSearch: this.state.pacerSearch,
      buyDocketSheet: this.buyDocketSheet,
      clear: this.clear,
    };

    const docketEntriesProps = {
      entries,
      lastUpdated,
      showMissingDockets,
      dockets: this.props.dockets,
      redactSeqNum: this.state.redactSeqNum,
      buyMissingDockets: this.buyMissingDockets,
      getDocketDetails: this.getDocketDetails,
      showRedactPopup: this.showRedactPopup,
      buyPdf: this.buyPdf,
      case_uuid: this.props.case_uuid,
      sortDockets: this.sortDockets,
      updateClick: this.updateClick,
      pastEntriesClick: this.pastEntriesClick,
      onPopupClick: this.onPopupClick,
      selectedDocketDetailNum: this.state.selectedDocketDetailNum,
      reloadDetails: this.reloadDetails,
    };

    const docketsPaginatorProps = {
      dockets: this.props.dockets,
      case_uuid: this.props.case_uuid,
      selectedPageNum: this.state.selectedPageNum,
      changePage: this.changePage,
      onPopupClick: this.onPopupClick,
      toggleHeader: this.toggleHeader,
      dispatch: this.props.dispatch,
    };

    const { name } = this.props.popup;
    const DocketsPopup = this.popupForm[name];

    if (this.state.showLoadingBar) {
      if (!_.has(this.props.dockets, 'entries')) {
        return (
          <div className="docket">
            <div id="dockets-tabs">
              <LoadingBar />
            </div>
          </div>
        );
      }

      return (
        <div className="docket">
          <div id="dockets-tabs">
            { this.state.showSearchBar && <DocketPacerSearchBar {...docketSearchBarProps} /> }
            <div className="">

              <FilterTable className={`filter-table ${this.state.collapseHeader ? 'collapsed' : ''}`}
                           Header={DocketFilters}
                           headerProps={docketFilterProps}>

                { showMissingDockets && <MissingEntriesTooltip /> }

                { this.props.docketHeader.hasMoreRecentFilingsDate &&
                  <LastFilingTooltip date={this.props.docketHeader.hasMoreRecentFilingsDate} />
                }

                <DocketsPaginator {...docketsPaginatorProps} hasToolbar />

                <DocketHeader open={!this.state.collapseHeader} data={headers} lastUpdated={lastUpdated} />

                <DocketError errors={this.props.error} />

                { this.state.contactingPacer &&
                  <div className="contacting">Contacting Pacer...</div>
                }

                <LoadingBar />

                <DocketsPaginator {...docketsPaginatorProps} />

              </FilterTable>

              { !_.isEmpty(this.props.receipt) && (
                <SearchReceipt receipt={Immutable.fromJS({ text: this.props.receipt })} />
              )}
            </div>
          </div>
        </div>
      );
    }

    if (this.state.loadCount < 2 && this.state.showSearchBar && !this.state.showPastEntries) {
      return (
        <div className="docket">
          <div id="dockets-tabs">
            { this.state.showSearchBar && <DocketPacerSearchBar {...docketSearchBarProps} /> }
            <DocketError errors={this.props.error} />
          </div>
        </div>
      );
    }

    const clsName = this.state.showPastEntries
      ? 'show-past-entries'
      : '';

    return (
      <div className="docket">

        <Flash show={this.props.docketParts.showFlash} mailto={this.props.docketParts.email_address} />

        <div id="dockets-tabs">
          { this.state.showSearchBar && <DocketPacerSearchBar {...docketSearchBarProps} /> }
          <div className={clsName}>

            <FilterTable className={`filter-table ${this.state.collapseHeader ? 'collapsed' : ''}`}
                         Header={DocketFilters}
                         headerProps={docketFilterProps}>

              { showMissingDockets && <MissingEntriesTooltip /> }

              { this.props.docketHeader.hasMoreRecentFilingsDate &&
                <LastFilingTooltip date={this.props.docketHeader.hasMoreRecentFilingsDate} />
              }

              <DocketsPaginator {...docketsPaginatorProps} hasToolbar />

              <DocketHeader open={!this.state.collapseHeader} data={headers} lastUpdated={lastUpdated} />

              <DocketError errors={this.props.error} />

              { headers && !_.isEmpty(headers.text) && (
                <DocketEntries {...docketEntriesProps} />
              )}

              <DocketsPaginator {...docketsPaginatorProps} />

            </FilterTable>

            { !_.isEmpty(this.props.receipt) && (
              <SearchReceipt receipt={Immutable.fromJS({ text: this.props.receipt })} />
            )}

            <UpdateRedact
              showRedactPopup={this.state.showRedactPopup}
              closeRedactPopup={this.closeRedactPopup}
              redact={this.redact} />

            <DocketsPopup
              onClose={this.onPopupClick}
              info={this.props.popup}
              reloadDetails={this.reloadDetails} />
          </div>
        </div>
      </div>
    );
  }
}

Docket.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
  lastUpdated: null,
};

Docket.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  dockets: PropTypes.object.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  docketHeader: PropTypes.object.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();
  const dockets = irSearch.data.reduce((accum, next) => {
    // eslint-disable-next-line
    accum[next[0]] = next[1];
    return accum;
  }, {});

  const { popup, docketParts, docketHeader } = state.get('dockets').toJS();

  return {
    dataReady: irSearch.data_ready,
    dockets,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
    popup,
    docketParts,
    docketHeader,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Docket);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/Docket.js
 **/